import { queryOptions } from '@tanstack/react-query'

import { dictionariesApi } from './dictionariesApi'

export const dictionariesQueries = {
  all: () => ['dictionaries'] as const,
  paymentTypes: () =>
    queryOptions({
      queryKey: [...dictionariesQueries.all(), 'paymentTypes'],
      queryFn: ({ signal }) => dictionariesApi.getPaymentTypes({ signal }),
      staleTime: Infinity,
    }),
  currencies: () =>
    queryOptions({
      queryKey: [...dictionariesQueries.all(), 'currencies'],
      queryFn: ({ signal }) => dictionariesApi.getCurrencies({ signal }),
      staleTime: Infinity,
    }),
}
